/**
* What We Do Sticky Menu JS
* -----------------------------------------------------------------------------
*
* All the JS for the What We Do Sticky Menu component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';

( function( app ) {
  const COMPONENT = {

    className: 'what-we-do-sticky-menu',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( ScrollToPlugin );

      let navHeight = 120;

      if ( document.body.classList.contains( 'logged-in' ) ) {
        navHeight = 148;
      }

      ScrollTrigger.create( {
        trigger: '.sticky-menu-wwd-container',
        start: 'top top+=50px',
        endTrigger: 'html',
        end: 'bottom top',
        toggleClass: 'active',
      } );

      ScrollTrigger.create( {
        trigger: '.sticky',
        start: 'top top+='+navHeight,
        endTrigger: 'html',
        end: 'bottom top',
        pin: '.sticky-menu-wwd-container',
        pinSpacing: false,
        anticipatePin: true,
        scrub: false,
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'what-we-do-sticky-menu', COMPONENT );
} )( app );
